import React from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import routeUsesMatrix from './matrixRoutePolicy';
import ErrorBoundary from '../components/ErrorBoundary';
import { lazyWithReload } from '../utils/lazyWithReload';

const MatrixProvider = lazyWithReload(
  () => import('./MatrixProvider').then((module) => ({ default: module.MatrixProvider })),
  'matrix-provider',
);

export default function MatrixRouteBoundary({ children }) {
  const { pathname } = useLocation();

  if (!routeUsesMatrix(pathname)) {
    return children;
  }

  return (
    <ErrorBoundary componentName="MatrixRouteBoundary">
      <React.Suspense
        fallback={
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh', bgcolor: '#070707' }}>
            <CircularProgress sx={{ color: '#D37633' }} />
          </Box>
        }
      >
        <MatrixProvider>{children}</MatrixProvider>
      </React.Suspense>
    </ErrorBoundary>
  );
}
